export enum ProductStateType {
    Inactive = 0,
    Active = 1,
    OnRequest = 2,
    Discontinued = 3,
};

export enum LeadFormCondition {
  OnRequest = "ON_REQUEST",
  WithoutPrice = "WITHOUT_PRICE",
  OutOfStock = "OUT_OF_STOCK",
}

export const PaginationMaxPages: number = 500;
export const PaginationStep: number = 20;
export const BrandLogoEnabled = false;

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const PHONE_REGEX = /^(?=(?:\D*\d){7,})\+?[0-9\s\-()]+$/;
